import { Request } from '~src/httpClient/serverApi/requests/Request';

import { AddOrUpdateCustomDomainSettingRequest, CustomDomainSettingResponse } from '../types/CustomDomainTypes';
import { headers } from './GetCustomDomainRequest';

export class AddCustomDomainRequest extends Request<AddOrUpdateCustomDomainSettingRequest,  CustomDomainSettingResponse> {
  constructor(params: AddOrUpdateCustomDomainSettingRequest) {
    super('POST', params, headers);
  }
}

export class UpdateCustomDomainRequest extends Request<AddOrUpdateCustomDomainSettingRequest,  CustomDomainSettingResponse> {
  constructor(params: AddOrUpdateCustomDomainSettingRequest) {
    super('PUT', params, headers);
  }
}